import { createSlice } from "@reduxjs/toolkit";

interface FoundationAccrualProgram {
    id: string
    name: string
}

interface FoundationAccrualState {
    isFoundationAccrualModalOpen: boolean
    onAccrual: (() => void) | null
    selectedProgram: FoundationAccrualProgram | null
}

const initialState: FoundationAccrualState = {
    isFoundationAccrualModalOpen: false,
    onAccrual: null,
    selectedProgram: null
}

const foundationAccrualSlice = createSlice({
    name: 'foundationAccrual',
    initialState,
    reducers: {
        openFoundationAccrualModal: (state, action) => {
            state.isFoundationAccrualModalOpen = true
            state.onAccrual = action.payload?.onSuccess ?? null
            state.selectedProgram = action.payload?.program ?? null
        },
        closeFoundationAccrualModal: (state) => {
            state.isFoundationAccrualModalOpen = false
            state.selectedProgram = null
        },
    }
})

export default foundationAccrualSlice.reducer
export const { closeFoundationAccrualModal, openFoundationAccrualModal } = foundationAccrualSlice.actions
